import { render, staticRenderFns } from "./ElButtonSeparate.vue?vue&type=template&id=f6e4296c&scoped=true&"
import script from "./ElButtonSeparate.vue?vue&type=script&lang=js&"
export * from "./ElButtonSeparate.vue?vue&type=script&lang=js&"
import style0 from "./ElButtonSeparate.vue?vue&type=style&index=0&id=f6e4296c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e4296c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
